import {CreateEquipmentCategoryDto, EquipmentCategory} from "../../../../model/Dto/Dict/EquipmentCategory";
import {ApiRequest, RequestMethod} from "../../../request";

const URL = "/api/equipment-category";

export async function createEquipmentCategory(data: CreateEquipmentCategoryDto): Promise<EquipmentCategory | null> {
    const apiRequest = new ApiRequest();
    apiRequest.setMethod(RequestMethod.POST);
    apiRequest.setUrl(URL);
    apiRequest.setJsonBody(data);
    const response: any = await apiRequest.send();
    if (response.status === 200) return response.data;
    return null;
}